import { render, staticRenderFns } from "./dashboard-performance.vue?vue&type=template&id=0a9b4950"
import script from "./dashboard-performance.vue?vue&type=script&lang=js"
export * from "./dashboard-performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports